import React from 'react';
import InfoField from './InfoField';

const EmploymentDetailsSection = ({ employmentChecks }) => {
  if (!employmentChecks || employmentChecks.length === 0) {
    return (
      <div className="report-section">
        <h2 className="section-title">Employment Details</h2>
        <p>No employment details available.</p>
      </div>
    );
  }

  return (
    <div className="admin-report-section">
      <h2 className="admin-section-title">Employment Details</h2>
      {employmentChecks.map((emp, index) => (
        <div key={index} className="employment-entry-card"> {/* Added a card-like container for each entry */}
          <h3>Employment Entry {index + 1}</h3>
          <div className="grid-container">
            <InfoField label="Employee Code" value={emp.employeeCode || 'N/A'} />
            <InfoField label="Company Name" value={emp.companyName || 'N/A'} />
            <InfoField label="Job Title" value={emp.jobTitle || 'N/A'} />
            <InfoField label="Location" value={emp.location || 'N/A'} />
            <InfoField label="HR Contact Number" value={emp.hrContactNumber || 'N/A'} />
            <InfoField label="HR Contact Email" value={emp.hrContactEmail || 'N/A'} />
            <InfoField label="Working From" value={emp.workingFrom || 'N/A'} />
            <InfoField label="Working To" value={emp.workingTo || 'N/A'} />
            <InfoField label="Remarks" value={emp.remarks || 'N/A'} />
            <InfoField label="Individual Status" value={emp.individualStatus || 'N/A'} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmploymentDetailsSection;